import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";


const styles = createUseStyles(theme => ({
  notification: {
    fontFamily: theme.fontFamily,
    marginBottom:"10px",
    background: theme.notification.background,
    padding: "16px",
    width: "400px",
    maxWidth: 400,
    minHeight: 114,
    border: theme.notification.border,
    borderRadius: "12px",
    boxShadow: theme.notification.boxShadow,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "354px",
    },
    [`@media (max-width: 374px)`]: {
      width: "auto",
    }
  },

  icon: {
    marginRight: "17px",
  },
  closeIcon: {
    cursor: "pointer",
    marginRight: "5px",
  },
  notificationWrapper: {
    width: "100%",
    display:"flex",
    alignContent:"flex-start",
    justifyContent:"flex-start"
  },
  notificationTitle: {
    display: "flex",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.notification.titleColor,
    marginTop: "5px",
    justifyContent: "space-between",
  },
  notificationContainer:{
    width:"100%",
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
  },
  iconContainer:{
    maxWidth: "280px"
  },

  notificationText: {
    fontSize: "14px",
    fontWeight: "400",
    color: theme.notification.color,
    overflowWrap: "break-word"
  },
  notificationDismiss: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.notification.color,
    marginTop: "16px",
    cursor: "pointer",
    width: "fit-content",
  },
  notifiContainer:{
    position: "fixed",
    right: "10px",
    top: "25px",
    zIndex: 2000
  }
}));

export default styles;
